import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getAttendanceColor, getAttendanceHoverColor } from 'utils/helpers';

const Container = styled.a`
	background: ${(props) => props.background || '#eeeeee'};
	position: relative;
	display: block;
	text-decoration: none;
	color: #fff;

	:hover {
		background: ${(props) => props.hover || '#eeeeee'};
		color: #fff;
		text-decoration: none;
	}
`;

const GoogleEventBlock = ({ event }) => {
	const { title, startTime, htmlLink } = event;

	return (
		<Container
			className="hand font-9 font-weight-bold w-100 p-2 border-top border-bottom"
			background={getAttendanceColor('GoogleCalendarEvent')}
			hover={getAttendanceHoverColor('GoogleCalendarEvent')}
			href={htmlLink}
			target="_blank"
			rel="noopener noreferrer"
		>
			<div>
				{startTime} {title}
			</div>
		</Container>
	);
};

GoogleEventBlock.propTypes = {
	event: PropTypes.shape({
		title: PropTypes.string,
		startTime: PropTypes.string,
		htmlLink: PropTypes.string,
	}).isRequired,
};

export default GoogleEventBlock;
